<template>
    <div class="basicInfo sr-view">
        <el-row class="row_box">
            <template v-for="(item, index) in formDataCopy">
                <!-- 没有type -->
                <el-col
                    :key="index"
                    :span="item.span || item.col"
                    v-if="!item.type && !item.isHide"
                    v-show="!item.hidden"
                    :class="item.class"
                >
                    <label class="label-item ellipsis" :title="item.label">{{
                        item.label
                    }}</label>
                    <span
                        class="overflow context"
                        v-if="
                            ruleFormCopy[item.value] &&
                            ruleFormCopy[item.value].length > 156
                        "
                    >
                        <span
                            :title="ruleFormCopy[item.value]"
                            v-show="!item.operateFlag"
                        >
                            {{ ruleFormCopy[item.value].slice(0, 150) + "..." }}
                        </span>
                        <span
                            :title="ruleFormCopy[item.value]"
                            v-show="item.operateFlag"
                            >{{ formatContext(item) }}</span
                        >
                    </span>
                    <template v-else>
                        <el-tooltip
                            popper-class="selfTip"
                            v-if="
                                item.showTip || formatContext(item).length >= 24
                            "
                            class="item"
                            effect="light"
                            :content="formatContext(item)"
                            placement="top"
                        >
                            <span class="context">
                                {{ formatContext(item) }}
                            </span>
                        </el-tooltip>
                        <span class="context" v-else>
                            {{ formatContext(item) }}
                        </span>
                    </template>
                </el-col>

                <!-- type=value -->
                <el-col
                    :key="index"
                    :span="item.span || item.col"
                    v-if="item.type == 'value' && !item.isHide"
                    v-show="!item.hidden"
                    :class="[item.class, 'value_box']"
                >
                    <label class="label-item ellipsis" :title="item.label">{{
                        item.label
                    }}</label>
                    <span
                        :class="[
                            'overflow',
                            'context',
                            item.class,
                            item.className,
                        ]"
                    >
                        <slot
                            v-if="item.valueSlot ? true : false"
                            :name="item.value"
                            :value="ruleFormCopy[item.value]"
                        ></slot>
                        <template v-else>
                            <div class="btn-more-wrapper" v-if="item.moreBtn">
                                <el-button
                                    v-if="moreBtnVisible(item)"
                                    type="text"
                                    class="btn-more"
                                    @click="showDialog(item)"
                                    >更多</el-button
                                >
                                <span
                                    :ref="`${item.value}Ref`"
                                    :title="formatContext(item)"
                                    >{{ formatContext(item) }}</span
                                >
                            </div>
                            <span v-else :title="formatContext(item)">{{
                                formatContext(item)
                            }}</span>
                        </template>
                    </span>
                </el-col>

                <!-- type=slot -->
                <el-col
                    :key="index"
                    :span="item.span ? item.span : 24"
                    v-if="item.type == 'slot'"
                    :class="[item.class, 'value_box']"
                >
                    <slot :name="item.slotName"></slot>
                </el-col>

                <!-- type=editor -->
                <el-col
                    :key="index"
                    :span="item.span || item.col"
                    v-if="item.type == 'editor'"
                    class="editor_box"
                    :class="[item.class, 'editor_box']"
                >
                    <label class="label-item ellipsis" :title="item.label">{{
                        item.label
                    }}</label>
                    <SrEditor
                        :maxlength="item.maxlength ? item.maxlength : 0"
                        :showBtn="item.showBtn"
                        :type="item.readonly"
                        ref="SrEditor"
                        :placeholder="item.placeholder"
                        :value="ruleFormCopy[item.value]"
                    />
                </el-col>
                <!--uploader -->
                <el-col
                    :key="index"
                    :span="item.span || item.col || 24"
                    v-else-if="
                        item.type &&
                        item.type.startsWith('uploader') &&
                        !item.isHide
                    "
                    :class="[item.class, 'html_box']"
                >
                    <label class="label-item ellipsis" :title="item.label">{{
                        item.label
                    }}</label>
                    <upload-view-xian
                        :data-up="item"
                        :view-data="ruleFormCopy[item.value] || []"
                        :emptyPlacehoder="item.emptyPlacehoder"
                        v-if="origin.includes('xian')"
                    ></upload-view-xian>
                    <UploaderView
                        :data-up="item"
                        :view-data="ruleFormCopy[item.value] || []"
                        :emptyPlacehoder="item.emptyPlacehoder"
                        v-else
                    ></UploaderView>
                </el-col>

                <!-- uploadImg -->
                <el-col
                    :key="index"
                    :span="item.span || item.col || 24"
                    v-else-if="
                        item.type && item.type === 'uploadImg' && !item.isHide
                    "
                    :class="[item.class, 'html_box']"
                >
                    <label class="label-item ellipsis" :title="item.label">{{
                        item.label
                    }}</label>
                    <UploadImg
                        :view-data="ruleFormCopy[item.value]"
                        v-bind="item"
                    />
                </el-col>

                <!-- html -->
                <el-col
                    :key="index"
                    :span="item.span || item.col || 24"
                    v-else-if="item.type == 'html' && !item.isHide"
                    :class="[item.class, 'html_box']"
                >
                    <label class="label-item ellipsis" :title="item.label">{{
                        item.label
                    }}</label>
                    <!-- <SrMultipleText
                        v-model="ruleFormCopy[item.value]"
                        :item="item"
                        ref="SrMultipleText"
                        v-if="ruleFormCopy[item.value] && item.textarea"
                    ></SrMultipleText>
                    <div
                        class="context"
                        v-else-if="ruleFormCopy[item.value]"
                        v-html="ruleFormCopy[item.value]"
                    ></div> -->
                    <div class="context" v-if="!ruleFormCopy[item.value]">
                        -
                    </div>
                    <template v-else>
                        <div
                            v-if="item.moreBtn"
                            :class="['overflow', 'context']"
                        >
                            <div class="btn-more-wrapper" v-if="item.moreBtn">
                                <el-button
                                    v-if="moreBtnVisible(item)"
                                    type="text"
                                    class="btn-more"
                                    @click="showDialog(item)"
                                    >更多</el-button
                                >
                                <span
                                    :ref="`${item.value}Ref`"
                                    :title="formatContext(item)"
                                    >{{ formatContext(item) }}</span
                                >
                            </div>
                        </div>
                        <SrMultipleText
                            v-else-if="
                                ruleFormCopy[item.value] && item.textarea
                            "
                            v-model="ruleFormCopy[item.value]"
                            :item="item"
                            ref="SrMultipleText"
                        ></SrMultipleText>
                        <div v-else :title="formatContext(item)" v-html="ruleFormCopy[item.value]"></div>
                    </template>
                </el-col>
                <!-- textarea -->
                <el-col
                    :key="index"
                    :span="item.span || item.col || 24"
                    v-else-if="item.type == 'textarea' && !item.isHide"
                    :class="[item.class, 'html_box']"
                >
                    <label class="label-item ellipsis" :title="item.label">{{
                        item.label
                    }}</label>
                    <SrMultipleText
                        v-model="ruleFormCopy[item.value]"
                        :item="item"
                        ref="SrMultipleText"
                        v-if="ruleFormCopy[item.value]"
                    ></SrMultipleText>
                    <div class="context" v-else>-</div>
                </el-col>
                <!-- 评分展示 -->
                <el-col
                    :key="index"
                    :span="item.span || item.col"
                    v-else-if="item.type === 'star'"
                    :class="[item.class, 'star_box']"
                >
                    <label class="label-item ellipsis" :title="item.label">{{
                        item.label
                    }}</label>
                    <div class="context" @click="sendEvent(item.eventName)">
                        <el-rate
                            :value="ruleFormCopy[item.value]"
                            disabled="disabled"
                            :score-template="ruleFormCopy[item.value] + '分'"
                            v-bind="item"
                        ></el-rate>
                    </div>
                </el-col>
            </template>
        </el-row>
        <el-dialog
            v-if="valueDialog.visible"
            :title="valueDialog.title"
            :visible.sync="valueDialog.visible"
            width="800px"
            center
            class="value-dialog"
        >
            <div class="value-dialog-content">
                <div
                    v-if="valueDialog.isHtml"
                    v-html="valueDialog.content"
                ></div>
                <div v-else>{{ valueDialog.content }}</div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import UploaderView from "./uploaderView";
import UploadViewXian from "./uploaderViewXian.vue";
import UploadImg from "./uploadImgView";

// 防抖
function debounce(fn, delay) {
    let timer = null;
    return function () {
        let context = this;
        let args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
            fn.apply(context, args);
        }, delay);
    };
}

export default {
    components: {
        UploaderView,
        UploadViewXian,
        UploadImg,
    },
    inject: ["baseUrl"],
    name: "SrView",
    props: {
        formData: {
            type: Array,
            default: () => {
                return [];
            },
        },
        ruleForm: {
            type: Object,
            default: () => {
                return {};
            },
        },
        enums: Object,
        emptyPlacehoder: {
            type: String,
            default: () => {
                // 是否隐藏为空时，显示的占位- -
                return "-";
            },
        },
    },
    data() {
        return {
            operateFlag: false,
            bgArr: [],
            expand: false,
            formDataCopy: [],
            ruleFormCopy: {},
            valueDialog: {
                visible: false,
                title: "",
                content: "",
            },
            isMounted: false,
        };
    },
    computed: {
        moreBtnVisible: {
            get() {
                return function ({ moreBtn = false, value = "" }) {
                    if (!this.isMounted) return false;
                    const contextNode = this.$refs[`${value}Ref`][0];
                    // !scrollWidth && (scrollWidth = contextNode.parentNode.scrollWidth)
                    // !offsetWidth && (offsetWidth = contextNode.parentNode.offsetWidth)
                    return (
                        moreBtn &&
                        contextNode.parentNode.scrollWidth >
                            contextNode.parentNode.offsetWidth
                    );
                };
            },
        },
        origin() {
            return sessionStorage.getItem('origin') || '';
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.isMounted = true;
        });
        this.$set(
            this,
            "formDataCopy",
            JSON.parse(JSON.stringify(this.formData))
        );
        this.$set(
            this,
            "ruleFormCopy",
            JSON.parse(JSON.stringify(this.ruleForm))
        );
    },
    watch: {
        formData: {
            handler: function (val, old) {
                this.$set(
                    this,
                    "formDataCopy",
                    JSON.parse(JSON.stringify(val))
                );
            },
            deep: true,
        },
        ruleForm: {
            handler: function (val) {
                this.$set(
                    this,
                    "ruleFormCopy",
                    JSON.parse(JSON.stringify(val))
                );
            },
            deep: true,
        },
    },
    methods: {
        showDialog({ label = "", value = "", type = "" } = {}) {
            console.log({ label, value });
            this.valueDialog.visible = true;
            this.valueDialog.title = label;
            this.valueDialog.content = this.ruleFormCopy[value];
            this.valueDialog.isHtml = type === "html";
        },
        getWidth(item) {
            return {
                width:
                    "calc(100% - " +
                    (item.labelWidth ? item.labelWidth + 25 : 100) +
                    "px)",
            };
        },
        /**
         * 点击
         */
        sendEvent(eventName) {
            this.$emit("eventNotify", eventName);
        },
        formatContext(item) {
            if (item.type == "html") {
                const div = document.createElement("div");
                div.innerHTML = this.ruleFormCopy[item.value];
                return div.innerText;
            }
            if ([null, "", undefined].includes(this.ruleFormCopy[item.value])) {
                return this.emptyPlacehoder;
            } else {
                return this.ruleFormCopy[item.value];
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// packages/SrView/SrView.vue